import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../modules/angular-material/angular-material.module';
import { BasicStatComponent } from './components/basic-stat/basic-stat.component';
import { NiceCardComponent } from './components/nice-card/nice-card.component';

const declarations = [BasicStatComponent, NiceCardComponent];

@NgModule({
  imports: [AngularMaterialModule, CommonModule],
  declarations,
  exports: declarations,
})
export class VisualizationsModule {}
